import { render, staticRenderFns } from "./emptyLayout.vue?vue&type=template&id=232e1cfc&scoped=true"
import script from "./emptyLayout.vue?vue&type=script&lang=js"
export * from "./emptyLayout.vue?vue&type=script&lang=js"
import style0 from "./emptyLayout.vue?vue&type=style&index=0&id=232e1cfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e1cfc",
  null
  
)

export default component.exports